import React from "react";
import Layout from "../components/containers/Layout.component";
import LandingHero from "../components/organisms/LandingHero/LandingHero.component";
import Workflow from "../components/containers/Workflow/Workflow.component";
import Collection from "../components/containers/Collection/Collection.component";
import CustomerStories from "../components/containers/CustomerStories/CustomerStories.component";
import Plans from "../components/containers/Plans/Plans.component";
import TrustFaqs from "../components/containers/TrustFaqs/TrustFaqs.component";

const Home = () => {
  return (
    <Layout>
      <LandingHero />
      <Workflow />
      <Collection />
      <CustomerStories />
      <Plans />
      <TrustFaqs />
    </Layout>
  );
};

export default Home;
